<script setup lang="ts">
const m2Product = inject('m2Product')
const attributeGroups = inject('attributeGroups')
const bynderAssets = inject('bynderAssets')
const deliveryAndReturns = inject('deliveryAndReturns')
const stockAndDelivery = inject('stockAndDelivery')

const productDesignStoryDialog = useUiDialog('design-story-dialog')
const productStockAndDeliveryDialog = useUiDialog('stock-and-delivery-dialog')
const productDimensionsAndDetailsDialog = useUiDialog('dimensions-and-details-dialog')
const productDeliveryAndReturnsDialog = useUiDialog('delivery-and-returns-dialog')
const productBrochureAndDownloadsDialog = useUiDialog('brochure-and-downloads-dialog')
// const productReviewsDialog = useUiDialog('product-reviews-dialog')
</script>

<template>
  <div
    id="specifications"
    class="product-panels"
  >
    <template v-if="attributeGroups?.length">
      <button
        class="product-panels__trigger"
        type="button"
        @click="productDimensionsAndDetailsDialog.open()"
      >
        <span>{{ $t('Dimensions and Details') }}</span>
        <NuxtIcon name="icon:arrow" />
      </button>

      <ProductDimensionsAndDetailsDialog :attribute-groups="attributeGroups" />
    </template>

    <template v-if="m2Product?.description?.html?.trim()">
      <button
        class="product-panels__trigger"
        type="button"
        @click="productDesignStoryDialog.open()"
      >
        <span>{{ $t('The story behind the design') }}</span>
        <NuxtIcon name="icon:arrow" />
      </button>

      <ProductDesignStoryDialog />
    </template>

    <template v-if="stockAndDelivery?.Richtext?.length">
      <button
        class="product-panels__trigger"
        type="button"
        @click="productStockAndDeliveryDialog.open()"
      >
        <span>{{ stockAndDelivery.Title }}</span>
        <NuxtIcon name="icon:arrow" />
      </button>

      <ProductStockAndDeliveryDialog />
    </template>

    <template v-if="deliveryAndReturns?.Richtext?.length">
      <button
        class="product-panels__trigger"
        type="button"
        @click="productDeliveryAndReturnsDialog.open()"
      >
        <span>{{ deliveryAndReturns.Title }}</span>
        <NuxtIcon name="icon:arrow" />
      </button>

      <ProductDeliveryAndReturnsDialog />
    </template>

    <template v-if="bynderAssets?.length">
      <button
        class="product-panels__trigger"
        type="button"
        @click="productBrochureAndDownloadsDialog.open()"
      >
        <span>{{ $t('Brochure & downloads') }}</span>
        <NuxtIcon name="icon:arrow" />
      </button>

      <ProductBrochureAndDownloadsDialog />
    </template>

    <!--
    <template v-if="1">
      <button
        class="product-panels__trigger"
        type="button"
        @click="productReviewsDialog.open()"
      >
        <span>Productreviews</span>
        <NuxtIcon name="icon:arrow" />
      </button>
      <ProductReviewsDialog />
    </template>
    -->
  </div>
</template>

<style>
@import url('~layers/components/Product/Panels.css');
</style>
